module.exports = __webpack_public_path__ + "static/img/slide_2_en.0f79c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_2_en.png
// module id = iOgM
// module chunks = 0